import React from 'react';
import I18n from 'i18n-js';
import { debounce, defaults } from 'lodash';
import { formatNumber } from '../money';
import Currency from '../currency';
import { I18N } from '../components/translate';

interface IProps {
  offerAmount?: string;
  originalAmount: string;
  delay?: number;
  currency: string;
}

const LOWBALL_NUDGE_THRESHOLD = 0.75;
const HIGHBALL_NUDGE_THRESHOLD = 1;
const NUDGE_DELAY = 800; // milliseconds

export default class OffersNudge extends React.Component<IProps, null> {
  static defaultProps = {
    delay: NUDGE_DELAY,
  };

  debouncedUpdate = debounce(this.forceUpdate, this.props.delay);

  shouldComponentUpdate(nextProps) {
    if (this.props.delay === 0 || !nextProps.offerAmount) {
      return true;
    }

    this.debouncedUpdate();
    return false;
  }

  componentWillUnmount() {
    this.debouncedUpdate.flush();
  }

  render() {
    const { offerAmount, originalAmount } = this.props;

    if (!offerAmount) {
      return null;
    }

    const { symbol, displayCode } = defaults(Currency.get(this.props.currency), { symbol: '', displayCode: '' });
    const offerAmountRatio = parseInt(offerAmount, 10) / parseInt(originalAmount, 10);
    const formattedAmount = formatNumber(parseInt(offerAmount, 10));
    const formattedAmountWithCurrency = `${symbol}${formattedAmount} ${displayCode}`.trim();

    if (offerAmountRatio < LOWBALL_NUDGE_THRESHOLD) {
      return (
        <section className="offers-nudge offers-nudge--lowball">
          <h1 className="offers-nudge__title">
            {I18n.t('commons.offers.nudgeHeaderLowball')}
          </h1>
          <p className="offers-nudge__disclaimer">
            {I18n.t('commons.offers.nudgeDisclaimerLowball')}
          </p>
        </section>
      );
    }

    if (offerAmountRatio > HIGHBALL_NUDGE_THRESHOLD) {
      return (
        <section className="offers-nudge offers-nudge--highball">
          <h1 className="offers-nudge__title">
            {I18n.t('commons.offers.nudgeHeaderHighball')}
          </h1>
          <p className="offers-nudge__disclaimer">
            <I18N
              html
              text="commons.offers.nudgeDisclaimerHighball"
              args={{
                amount: formattedAmountWithCurrency,
                tagOpen: '<span class="weight-bold">',
                tagClose: '</span>',
              }}
            />
          </p>
        </section>
      );
    }

    return null;
  }
}
